import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonVariant, IButtonProps } from '@amobee/component-library';
import { MiscAdapter } from 'src/adapters/misc-adapter';
import { UserInfo } from 'src/app/data/classes/user-info';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {

    @Input() open: boolean;
    @Output() openChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() user: UserInfo;

    contactEmail = environment.contactEmail;

    okButton: IButtonProps = {
        variant: ButtonVariant.PRIMARY,
        label: 'OK',
        onClick: () => {
            this.cancel();
        }
    };

    constructor(private miscAdapter: MiscAdapter) { }

    ngOnInit() {
    }

    cancel() {
        this.open = false;
        this.openChange.emit(this.open);
    }

    resetPassword() {
        this.miscAdapter.sendForgotPasswordEmail(this.user.email)
            .catch(err => {
                console.error(err);
            });
    }
}
